import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import DescriptionIcon from "@mui/icons-material/Description";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import EditIcon from "@mui/icons-material/Edit";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { useNavigate } from "react-router-dom";
import { TreeParameters } from "../models/TreeParameter";

type Props = {
	setShelfNodeSelectedInTree: (node: any | null) => void;
	setShowModal: (
		modal: "new" | "edit" | "delete" | "view" | "move" | "",
	) => void;
};

export const useShelvesOptionsFunctions = ({
	setShelfNodeSelectedInTree,
	setShowModal,
}: Props) => {
	const navigate = useNavigate();

	const getMenuOptions = (data: TreeParameters) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Shelf",
				key: "new_shelf",
				onClick: () => {
					if (!data) {
						setShelfNodeSelectedInTree(null);
					}
					setShowModal("new");
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Edit Shelf",
					key: "edit_shelf",
					onClick: () => {
						setShowModal("edit");
					},
					icon: <EditIcon />,
				},
			]);
			// Main branches (at the top, holding groups) cannot move; loose shelves at the top can
			if (!(data.parent === 0 && data.droppable)) {
				options = options.concat([
					{
						name: "Move Shelf",
						key: "move_shelf",
						onClick: () => {
							setShowModal("move");
						},
						icon: <DriveFileMoveIcon />,
					},
				]);
			}
			options = options.concat([
				{
					name: "View Shelf",
					key: "view_shelf",
					onClick: () => {
						setShowModal("view");
					},
					icon: <FindInPageIcon />,
				},
				{
					// Browser Documents filtered on this node, to see what it holds
					name: "View Documents",
					key: "view_documents",
					onClick: () => {
						navigate(`/browser-documents/?shelfId=${data.id}`, {
							state: { listShelfId: data.id },
						});
					},
					icon: <DescriptionIcon />,
				},
			]);
			if (!data.droppable) {
				options = options.concat([
					{
						name: "Delete Shelf",
						key: "delete_shelf",
						onClick: () => {
							setShowModal("delete");
						},
						icon: <DeleteIcon />,
					},
				]);
			}
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
